<template>
  <GroupedPlayersBox
    :players="players"
    :allowedPlayers="allowedPlayers"
    :groupLimit="groupLimit"
    :groups="displayGroups"
    :pendingModerators="pendingModerators"
    :phase="phase"
    @update:groups="handleGroupsUpdate"
    @update:moderators="handleModeratorsUpdate"
/>
</template>

<script>
import { defaultAvatar } from "@/utils/data";
import styles from "@/css/PlayersBox.module.css";
import GroupedPlayersBox from "./GroupedPlayersBox.vue";

export default {
  components: { GroupedPlayersBox },
  name: "PlayersBox",
  props: {
    players: {
      type: Array,
      required: true,
      default: () => [],
    },
    allowedPlayers: {
      type: Number,
      required: true,
      default: null,
    },
     groups: {
      type: Array,
      required: true
    },
    groupLimit: {
      type: Number,
      required: true,
    },
    phase: {
      type: String,
      required: true,
    },
  },
  emits: ["update:groups", "update:moderators"],
  data() {
    return {
      defaultAvatar,
      localGroups: [],
      initialized: false,
      pendingModerators: {}, // { groupId: playerId }
    };
  },
  computed: {
    $style() {
      return styles;
    },
    displayGroups() {
      if (this.phase === "JOIN") {
        return this.localGroups;
      }

      return this.groups;
    }
  },
  methods: {
    buildDefaultGroups(playersList) {
      const groups = [];
      for (let i = 0; i < playersList.length; i += this.groupLimit) {
        const chunk = playersList.slice(i, i + this.groupLimit);
        const idx = Math.floor(i / this.groupLimit) + 1;
        groups.push({
          id: `temp-${idx}`,
          name: this.$t("group-label", { id: idx }),
          players: chunk,
        });
      }
      return groups;
    },

    // reconcileGroups(latestPlayers) {
    //   if (!this.groups.length) {
    //     this.groups = this.buildDefaultGroups(latestPlayers);
    //     this.emitGroups();
    //     return;
    //   }

    //   const latestPlayersById = new Map(
    //     latestPlayers.map((p) => [Number(p.id), p]),
    //   );

    //   // refresh players inside existing groups, remove missing players
    //   this.groups = this.groups.map((group) => ({
    //     ...group,
    //     players: group.players
    //       .filter((p) => latestPlayersById.has(Number(p.id)))
    //       .map((p) => latestPlayersById.get(Number(p.id))),
    //   }));

    //   // collect already assigned ids
    //   const assignedIds = new Set(
    //     this.groups.flatMap((g) => g.players.map((p) => Number(p.id))),
    //   );

    //   // add only newly joined players
    //   const unassignedPlayers = latestPlayers.filter(
    //     (p) => !assignedIds.has(Number(p.id)),
    //   );

    //   for (const player of unassignedPlayers) {
    //     let placed = false;

    //     for (const group of this.groups) {
    //       if (group.players.length < this.groupLimit) {
    //         group.players.push(player);
    //         placed = true;
    //         break;
    //       }
    //     }

    //     if (!placed) {
    //       const nextIndex = this.groups.length + 1;
    //       this.groups.push({
    //         id: `temp-${nextIndex}`,
    //         name: `Group ${nextIndex}`,
    //         players: [player],
    //       });
    //     }
    //   }

    //   // remove empty groups
    //   this.groups = this.groups.filter((group) => group.players.length > 0);

    //   // normalize names if needed
    //   this.groups = this.groups.map((group, index) => ({
    //     ...group,
    //     name: group.name || this.$t("group-label", { id: index + 1 }),
    //   }));

    //   this.emitGroups();
    // },

    handleGroupsUpdate(updatedGroups) {
      this.localGroups = updatedGroups.map((group, index) => ({
        ...group,
        id: group.id || `temp-${index + 1}`,
        name: group.name || this.$t("group-label", { id: index + 1 }),
      }));

      this.$emit("update:groups", this.localGroups);
    },
    handleModeratorsUpdate(updatedModerators) {
      this.pendingModerators = updatedModerators;
      this.$emit("update:moderators", updatedModerators);
    },
    emitGroups() {
      this.$emit("update:groups", this.localGroups);
    },
  },
  watch: {
    players: {
      immediate: true,
      deep: true,
      handler(newPlayers) {
        if (this.phase !== "JOIN") return;

        // First time → build groups
        if (!this.localGroups.length) {
          this.localGroups = this.buildDefaultGroups(newPlayers);
          this.$emit("update:groups", this.localGroups);
          return;
        }

        const existingIds = new Set(
          this.localGroups.flatMap(g => g.players.map(p => Number(p.id)))
        );

        const newJoinedPlayers = newPlayers.filter(
          p => !existingIds.has(Number(p.id))
        );

        for (const player of newJoinedPlayers) {
          let placed = false;

          for (const group of this.localGroups) {
            if (group.players.length < this.groupLimit) {
              group.players.push(player);
              placed = true;
              break;
            }
          }

          if (!placed) {
            const nextIndex = this.localGroups.length + 1;
            this.localGroups.push({
              id: `temp-${nextIndex}`,
              name: this.$t("group-label", { id: nextIndex }),
              players: [player],
            });
          }
        }

        this.$emit("update:groups", this.localGroups);
      },
    },
  },
};
</script>

<style scoped></style>